import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import * as lodash from 'lodash'
import { ContractTemplate, selectAllContractTemplateTags, selectAllGroups } from '@tokeet-frontend/signature'

export function createTemplateDetailsForm(formBuilder: FormBuilder) {
  return formBuilder.group({
    name: [undefined, [Validators.required]],
    description: [],
    title: [],
    message: [],
    expired_days: [undefined, [Validators.min(1)]],
    tags: [[]],
    groups: [[]],
  })
}

export function setTemplateDetailsFormData(form: FormGroup, template: ContractTemplate) {
  form.patchValue({
    name: template.name,
    description: template.description,
    title: template.title,
    message: template.message,
    expired_days: template.expired_days,
    tags: template.attributes?.tags || [],
    groups: template.groups || [],
  })
}

export function getTemplateDetailsFormData(form: FormGroup, template?: ContractTemplate) {
  const { tags, ...others } = form.getRawValue()
  return {
    ...others,
    attributes: {
      ...template?.attributes,
      tags,
    },
  }
}

@Component({
  selector: 'app-template-details-form',
  templateUrl: './template-details-form.component.html',
  styleUrls: ['./template-details-form.component.scss'],
})
export class TemplateDetailsFormComponent implements OnInit {
  @Input() form: FormGroup

  groups$ = this.store.pipe(select(selectAllGroups))
  tags$ = this.store.pipe(select(selectAllContractTemplateTags))

  availableExpiredDays = [
    {
      value: null,
      label: 'No Expiration',
    },
    ...lodash.range(1, 31).map((n) => ({
      value: n,
      label: `${n}`,
    })),
  ]

  constructor(private store: Store<any>) {}

  ngOnInit(): void {}
}
